function AboutMePage(){
    return (
        <section>
            <h1>Pan Gong</h1>
            <p>I am a second year computer science student at Dalhousie University.</p>
            <p>I create this website using ReactJS and firebase, then dockerized it with Docker and Nginx and deployed it to Google Cloud Provider. </p>
            <h2>Want to hear from you, you can send me email.</h2>
            <p><a  target="_blank">Pan.Gong@dal.ca</a></p>
            <div>
                <p>Linkedin: 
                <a href="https://www.linkedin.com/in/pan-gong-2764a4231/" target="_blank">Linkedin</a>
                </p>
            </div>
            <div>
                <p>Github:  
                <a href="https://github.com/panda022" target="_blank">https://github.com/panda022</a>
                </p>
            </div>
            

        </section>
    );
}

export default AboutMePage;